/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmdqAlertType = {
    FORECAST_ALERT: '01',
    READY_TO_SELL_ALERT: '02',
    MULTIPACK_ALERT: '03',
    SALES_SPACE_ALERT: '04',
    DISTRIBUTION_MODE_ALERT: '05',
    FULL_PALLET_ALERT: '06',
    PRODUCT_AREA_ALERT: '07',
} as const;
export type SmdqAlertType = typeof SmdqAlertType[keyof typeof SmdqAlertType];


export function instanceOfSmdqAlertType(value: any): boolean {
    for (const key in SmdqAlertType) {
        if (Object.prototype.hasOwnProperty.call(SmdqAlertType, key)) {
            if (SmdqAlertType[key as keyof typeof SmdqAlertType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SmdqAlertTypeFromJSON(json: any): SmdqAlertType {
    return SmdqAlertTypeFromJSONTyped(json, false);
}

export function SmdqAlertTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmdqAlertType {
    return json as SmdqAlertType;
}

export function SmdqAlertTypeToJSON(value?: SmdqAlertType | null): any {
    return value as any;
}

export function SmdqAlertTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SmdqAlertType {
    return value as SmdqAlertType;
}

